import { EMPTY_ID } from '@e-socna/empty-client';

import type { AdditionalFieldsValues } from '../types/additional-fields-render-props.type';

export const useInitialValuesFactory = (
  pInitialValues?: Readonly<AdditionalFieldsValues>,
) => ({
  initialValues: pInitialValues ?? { actionId: EMPTY_ID },
});
